import { Col, Row, Label, Spinner } from "reactstrap"
import { useState, useEffect } from "react"
import apiCall from "../../../utils/apiCall"
import apiConfig from "../../../config/apiConfig"
import StripeGenericContainer from "../../Stripe/stripeGeneric/StripeGenericContainer";


const WizardAdPayment = (props) => {
    const [downloadLink, setDownloadLink] = useState(null)
    const [fileName, setFileName] = useState('')

    useEffect(() => {
        if (props.baseObject.selectedContent !== 0 && props.baseObject.content && props.baseObject.content.length > 0) {
            const selectedContent = props.baseObject.content.find((con) => con.id === props.baseObject.selectedContent)
            if (selectedContent) {
                const downloadUrl = selectedContent.urls[0].url
                const title = props.baseObject.name || 'Your Podcast'
                setFileName(title.replace(/\s+/g, '-').toLowerCase() + '.mp3')
                setDownloadLink(downloadUrl)
            }
        }
    }, [props.baseObject]);


    const handleDownloadTranslation = async (linkUrl, languageCode) => {
        const translationTitle = `${fileName}`.replace('.mp3', `-${languageCode}.mp3`)

        try {
            const response = await fetch(linkUrl)
            const blob = await response.blob()

            const url = URL.createObjectURL(blob)

            const link = document.createElement('a')
            link.href = url
            link.download = translationTitle
            document.body.appendChild(link)
            link.click()

            document.body.removeChild(link)
            URL.revokeObjectURL(url)
        } catch (error) {
            console.error('Download failed:', error)
        }
    }

    const handlePurchase = async () => {
        let finishingTitle = false
        try {
            // Confirm purchase
            let resp = await apiCall(
                apiConfig.TRANSACTION.CONFIRM_PURCHASE + `?id=${props.purchaseObject.id}&advertId=${props.baseObject.id}`,
                "put"
            );
            if (resp.status === 200) {
                props.setPurchaseComplete(true)
                finishingTitle = props.purchaseObject
            }

            // Update download on ad content so we can download later
            resp = await apiCall(
                apiConfig.ADVERT.UPDATE_DOWNLOAD_STATUS + `?id=${props.baseObject.selectedContent}&downloadable=${props.advertCost.isDownload}`,
                "put"
            );
            if (resp.status === 200) {
                props.setPurchaseComplete(true)
            }
            props.setFinishingTitle(finishingTitle)

        } catch (error) {
            console.error(error.message);
        }
    }

    const selectedContent = props.baseObject.content.find(
        (item) => item.id === props.baseObject.selectedContent
    );

    return (
        <div className="pb-5">

            {!props.purchaseComplete ?
                props.purchaseObject ?
                    <Col>
                        <Row>
                            <Col>
                                <Label className="labelText">Cost</Label>
                                <div style={{ display: "flex", flexDirection: "column", width: "40%" }}>
                                    {props.advertCost.isNetwork &&
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <p>Ad Budget:</p>
                                            <p>&pound;{props.purchaseObject?.budget}</p>
                                        </div>
                                    }
                                    {props.advertCost.isDownload &&
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <p>Downloading {props.purchaseObject?.downloadQuantity}x advert:</p>
                                            <p>&pound;{props.purchaseObject?.downloadAmount.toFixed(2)}</p>
                                        </div>
                                    }
                                    {props.advertCost.vat != 0 ?
                                        <>
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                <p>VAT:</p>
                                                <p>&pound;{props.purchaseObject?.vat.toFixed(2)}</p>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                <p>Total:</p>
                                                <p>&pound;{props.purchaseObject?.amountDue.toFixed(2)}</p>
                                            </div>
                                        </>
                                        :
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <p>Total:</p>
                                            <p>&pound;{props.purchaseObject?.amountDue.toFixed(2)}</p>
                                        </div>
                                    }
                                </div>
                            </Col>

                            <Col>
                                <Row>
                                    <Col>
                                        <Label className="labelText">Card</Label>
                                        <StripeGenericContainer baseObject={props.purchaseObject} isAdSpend={true} setPurchaseComplete={props.setPurchaseComplete} handlePurchase={handlePurchase} />
                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                    </Col> : <Col className="text-center mt-4">
                        <Spinner />
                    </Col>

                :
                <Col>
                    <Row>
                        <Col className="text-center mt-4">

                            {props.advertCost.isDownload &&
                                <Col className="pt-4">
                                    {selectedContent &&
                                        selectedContent.urls &&
                                        selectedContent.urls.length > 0 && (
                                            <>
                                                {selectedContent.urls.filter(item => item.selected).map((dl) => (
                                                    <Col key={dl.languageCode}>
                                                        <Row className="mt-2 mb-2 justify-content-center">
                                                            <button
                                                                className="buttonStyle buttonPrimary"
                                                                style={{width: "250px", maxWidth:"250px"}}
                                                                onClick={() => handleDownloadTranslation(dl.url, dl.languageCode)}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "space-between",
                                                                        paddingLeft: 7,
                                                                        paddingRight: 7,
                                                                    }}
                                                                >
                                                                    <span>{dl.language}</span>
                                                                    <span>Download 
                                                                    <i className="fa fa-file-arrow-down pl-2" /></span>
                                                                </div>
                                                            </button>
                                                        </Row>
                                                    </Col>
                                                ))}
                                            </>
                                        )
                                    }
                                </Col>
                            }
                            <Col style={{ padding: "0 200px" }}>
                                <p><b>Congratulations</b> – you’ve created your advert and can now download it to use wherever and whenever you want (with no restrictions or licence or royalties fees to pay ever).</p>
                                <p>But did you know that we can fully manage its broadcast on radio or in podcasts for you for FREE?</p>
                                <p>You just set your advertising budget (from just £400+VAT*) and we work with our media partners to get your advert heard by thousands of your target customers in exactly the right locations, all without any additional charges from us.</p>
                                <p>Please contact us at <a href="mailto:hello@klaxon.ai" style={{ color: "red" }}>hello@klaxon.ai</a> or visit our website (<a href="https://klaxon.ai" target="_blank" rel="noopener noreferrer" style={{ color: "red" }}>www.klaxon.ai</a>) for more information.</p>
                                <p><i>*The fully managed broadcasting service has a minimum spend requirement of £1,200+VAT.</i></p>
                            </Col>
                        </Col>
                    </Row>
                </Col >
            }
        </div >
    )
}

export default WizardAdPayment 